import {lazy} from 'react';

export const BranchSearchListLazy = lazy(() => import(/* webpackChunkName: "branchSearchList" */ './list'));
export const BranchSearchMapAndListLazy = lazy(() => import(/* webpackChunkName: "branchSearchAmpAndList" */ './mapAndList'));
